module.exports = __webpack_public_path__ + "img/PL10139.43c810ab.png";